import { useParams } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'
import Data from './Data'
import MainGroup from './MainGroup'
import Download from '@cbgms/base/utils/download'
import { exportProductGroup, setProductGroupTranslation, updateProductGroup } from 'app-support/productgroup/state/actions'
import { IProductGroup, IProductGroupExportCategory, POSTProductGroupTranslationBody } from '@cbgms/api'
import * as Yup from 'yup'
import { BasicFormLayout, Form } from '@carsys/form'
import { Grid } from '@mui/material'
import { useNotifier } from '@cbgms/base/notifier'
import { useGetProductTree } from '../hooks/useGetProductTree'
import { useQueryClient } from '@cbgms/base/http/use-query'
import { productTreeCacheKey } from '../hooks/cache-keys'

export function TopMenu() {
  const { t } = useTranslation()
  const notifier = useNotifier()
  const dispatch = useDispatch()
  const queryClient = useQueryClient()
  const { tree_uuid } = useParams<{ tree_uuid: string }>()
  const { data: initialValues } = useGetProductTree(tree_uuid)

  const onSubmit = async (values: IProductGroup) => {
    const translation: POSTProductGroupTranslationBody = {
      Locale: values.Locale,
      Name: values.Name
    }

    try {
      await dispatch(updateProductGroup(values.UUID, values))
      await dispatch(setProductGroupTranslation(values.UUID, translation))
      queryClient.invalidateQueries(productTreeCacheKey(tree_uuid))
    } catch (e: any) {
      notifier.error(t('global.error'), e)
    }
    return values
  }

  const onSubmitSuccess = () => {
    notifier.success(t('global.successfully_saved'))
  }

  const onTreeExport = async () => {
    const Data = (await dispatch(exportProductGroup(tree_uuid))) as any as IProductGroupExportCategory

    Download.downloadFileFromText(`${initialValues?.Name}_${tree_uuid}.txt`, JSON.stringify(Data, null, 4))
  }

  const validationSchema = Yup.object().shape({
    Name: Yup.string().required(),
    IsActive: Yup.boolean().optional()
  })

  if (!initialValues) return null

  return (
    <Form
      NavigationConfirmation={null}
      initialValues={initialValues}
      onSubmit={onSubmit}
      onSubmitSuccess={onSubmitSuccess}
      validationSchema={validationSchema}
    >
      <BasicFormLayout backButtonProps={{ to: () => '/product-group' }}>
        <Grid container spacing={2} data-testid='top-menu-grid'>
          <Grid item xs={6}>
            <Data onTreeExport={onTreeExport} />
          </Grid>
          <Grid item xs={6}>
            <MainGroup ProductGroup={initialValues} />
          </Grid>
        </Grid>
      </BasicFormLayout>
    </Form>
  )
}

export default TopMenu
